import { Card } from '../../components/ui';
import { useMemberAuth } from '../../context/MemberAuthContext';

export function MemberDashboard() {
  const { me } = useMemberAuth();
  if (!me) return null;
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl">Welcome back, {me.firstName}</h1>
      <Card className="p-5 space-y-2">
        <div>
          <span className="text-ink-muted">Membership:</span> {me.membershipStatus}
        </div>
        <div>
          <span className="text-ink-muted">Dues:</span> {me.duesStatus}
          {me.duesPaidUntil && ` (paid through ${new Date(me.duesPaidUntil).toLocaleDateString()})`}
        </div>
      </Card>
    </div>
  );
}
